import React from 'react';
import { Score, Stacker, TypographyBody } from '@honeycomb/ui-core';
import { CustomerFeedback, useGlobalContext } from '@honeycomb/data';
import { formatCustomerRating } from '@honeycomb/ui';

export type CustomerRatingProps = {
    /**
     * The hotels's customer feedback details.
     */
    customerFeedback: CustomerFeedback;
};

export function CustomerRating({ customerFeedback }: CustomerRatingProps): React.JSX.Element {
    const { overallRating, overallRatingDescription } = customerFeedback || {};
    const {
        configSettings: { InHouseReviewScaleDivider },
    } = useGlobalContext();

    const rating = formatCustomerRating(overallRating || 0, parseInt(InHouseReviewScaleDivider));

    return (
        <Stacker direction="row" spacing={3} alignItems="center">
            <Score color="primary" size="s" data-id="brand_customer_rating">
                {rating}
            </Score>
            <TypographyBody component="div" weight="semiBold">
                {overallRatingDescription}
            </TypographyBody>
        </Stacker>
    );
}
